import React from 'react';
import { Switch, Route, Redirect } from 'skybolt-ui';
import List from './List';
import Create from './Create';
import Invoice from './Invoice';

export default function Invoices(props) {
  const {match:{ url, path }} = props;
  return (
    <Switch>
      <Route path={`${path}/list`} component={List}/>
      <Route path={`${path}/create`} component={Create}/>
      <Route path={`${path}/:invoiceId`} component={Invoice}/>
      <Redirect to={`${url}/list`}/>
    </Switch>
  );
}